import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ProfileState = {
  id: number | null;
  username: string | null;
  email: string | null;
  display_name: string | null;
  avatar_url: string | null;
  company_id: number | null;
  branch_id: number | null;
  role_id: number | null;
  status_id: number | null;
  phone_number: string | null;
  permission_codes: string[];
};

export const initialProfileState: ProfileState = {
  id: null,
  username: null,
  email: null,
  display_name: null,
  avatar_url: null,
  company_id: null,
  branch_id: null,
  role_id: null,
  status_id: null,
  phone_number: null,
  permission_codes: [],
};

const profileSlice = createSlice({
  name: 'profile',
  initialState: initialProfileState,
  reducers: {
    setProfile(state, action: PayloadAction<Partial<ProfileState> | null>) {
      if (!action.payload) return initialProfileState;
      return { ...state, ...action.payload };
    },
    resetProfile: () => initialProfileState,
  },
});

export const { setProfile, resetProfile } = profileSlice.actions;
export default profileSlice.reducer;
